module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "text-left",
    attrs: {
      "inline": _vm.inline,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "New Password",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('password', {
    attrs: {
      "toggle": _vm.toggle
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm New Password",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('password', {
    attrs: {
      "toggle": _vm.toggle
    },
    model: {
      value: (_vm.form.c_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "c_password", $$v)
      },
      expression: "form.c_password"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2564519a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/PasswordForm.vue
// module id = 1375
// module chunks = 0